@if (shouldShowSearchAgainButton) {
  <button
    id="searchAgainButton"
    class="search-area-button button pill-button secondary-button"
    type="button"
    (click)="searchAgain()"
  >
    <svg-icon src="/assets/icons/search.svg" alt="Search this area" i18n-alt />
    <span i18n>Search this area</span>
  </button>
}
